@if (!saving) {
  <sb-icon [name]="statusMapping[status].icon" />
  <span class="sr-only">{{ statusMapping[status].label | translate }}</span>
} @else {
  <sb-spinner [size]="'sm'" [strokeColor]="'current'"></sb-spinner>
}
